export enum DYNAMO_DB_TABLES {
  profiles = 'dev_Profiles',
  latestUpdates = 'dev_LatestUpdates',
  objectTemplates = 'dev_ObjectTemplates',
  customerObjects = 'dev_CustomerObjects',
}
